const LAND_COMMON_URL = {
  ROOT: '/',
  EMPTY: '/empty',
  NOT_FOUND: '/notfound',
  LOGIN: '/login',
  ERROR: '/error',
  MAINTENANCE: '/maintenance',
}

const LAND_SERVICE_PREFIX_URL = {
  MYHOUSE: '/myhouse',
  MYHOUSE_AUTH: '/myhouse/auth',
  MYHOUSE_COMPLEXES: '/myhouse/complexes',
  MYHOUSE_DENIED: '/myhouse/denied',
  MYHOUSE_GUIDE: '/myhouse/regist/guide',
  MYHOUSE_INTRODUCE: '/myhouse/introduce',
  MYHOUSE_NOTIFY: '/myhouse/notify',
  MYHOUSE_PENALTY: '/myhouse/penalty',
  MYHOUSE_REGISTER: '/myhouse/register',
  MYHOUSE_SETTINGS: '/myhouse/regist/settings', // TODO: ??? 확인후 /myhouse/settings로 변경
  MYHOUSE_PROMOTION_INSURANCE: '/myhouse/promotion/insurance',
}

const LAND_ALARM_PREFIX_URL = {
  MYHOUSE_CONFIRM: '/confirm',
}

const MEDIA_VIEWER_JS = {
  MOBILE: '/mobile-media-viewer1.1.4.min.js',
}

export { LAND_COMMON_URL, LAND_SERVICE_PREFIX_URL, LAND_ALARM_PREFIX_URL, MEDIA_VIEWER_JS }
